import React from 'react';
import InlineModal from '../../shared/InlineModal';
import AnchorLabeledList from '../../shared/AnchorLabeledList';
import { anchorAttributesForUrls, countOfListElements } from '../../utils';
import { Axis, Chart, Geom, Tooltip } from 'bizcharts';

type PageObjects = {
    css: string[];
    flash: string[];
    html: string[];
    images: string[];
    javascript: string[];
};

function getChartData(pageObjects: PageObjects) {
    return Object.entries(pageObjects).map(([type, objects]) => ({ objectType: type, objectCount: objects.length }));
}

type ResultModalProps = {
    objectList: string[];
    objectType: string;
};

function ResultModal({ objectList, objectType }: ResultModalProps) {
    return (
        <InlineModal
            openLabel={`${objectList.length} ${objectType}`}
            modalTitle={`${objectType} (${objectList.length})`}
            closeLabel="Close"
        >
            <AnchorLabeledList list={anchorAttributesForUrls(objectList)} />
        </InlineModal>
    );
}

type Props = {
    pageObjects: PageObjects;
};

export default function LegacyResult({ pageObjects }: Props) {
    const data = getChartData(pageObjects);

    const cols = {
        objectType: { alias: 'objectType' },
        objectCount: { alias: 'objectCount' },
    };

    return (
        <div className="description-meta">
            <div className="data-visualization">
                <div className="chart-legend">
                    <div className="totalPageObjects">Total Objects: {countOfListElements(pageObjects)}</div>
                    <ul>
                        <li>
                            <span className="legend-dot blue" />
                            <ResultModal
                                objectList={pageObjects.html}
                                objectType="HTML Pages"
                            />
                        </li>
                        <li>
                            <span className="legend-dot cyan" />
                            <ResultModal
                                objectList={pageObjects.css}
                                objectType="CSS Files"
                            />
                        </li>
                        <li>
                            <span className="legend-dot green" />
                            <ResultModal
                                objectList={pageObjects.javascript}
                                objectType="JS Files"
                            />
                        </li>
                        <li>
                            <span className="legend-dot yellow" />
                            <ResultModal
                                objectList={pageObjects.images}
                                objectType="Images"
                            />
                        </li>
                        <li>
                            <span className="legend-dot magenta" />
                            <ResultModal
                                objectList={pageObjects.flash}
                                objectType="Flash Files"
                            />
                        </li>
                    </ul>
                </div>

                <div className="chart-container">
                    <Chart
                        width={320}
                        height={260}
                        padding="auto"
                        data={data}
                        scale={cols}
                        className="chart"
                        forceFit
                    >
                        <Axis
                            name="objectType"
                            title={null}
                        />
                        <Axis
                            name="objectCount"
                            title={null}
                            position="left"
                        />
                        <Tooltip />
                        <Geom
                            type="interval"
                            position="objectType*objectCount"
                            color={['objectType', ['#3ba0ff', '#36cbcb', '#4dcb73', '#fad337', '#8543e0']]}
                        />
                    </Chart>
                </div>
            </div>
        </div>
    );
}
